import { GET_ADDRESS_BY_ID_SUCCESS, GET_ADDRESS_BY_ID_REQUEST, GET_ADDRESS_BY_ID_FAILURE } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getAddressByIdReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADDRESS_BY_ID_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_ADDRESS_BY_ID_REQUEST:
            return Object.assign({}, state);
        case GET_ADDRESS_BY_ID_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getAddressByIdReducer;
